export default "__VITE_ASSET__BY57hlSD__"